import { audioContextObj } from '@/assets/js/audioContext';
import { mapState } from 'vuex';
export default {
  props: {
    peerId: {
      type: String,
      default: ''
    },
    platForm: {
      type: String,
      default: ''
    },
    partyCode: {
      type: String,
      default: ''
    },
    anyWhereSetObj: {
      type: Object,
      default: function () {
        return {};
      }
    },
    degreeHost: [String, Number],
    devicesInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    rtc: {
      type: Object,
      default: () => {
        return {};
      }
    },
    singChannel: {
      type: Object,
      default: function () {
        return {};
      }
    },
    userInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      operationStatus: null,
      operationMessage: '',
      operationTimer: null,
      isSupportGimbal: '',
      isTopPressed: false,
      isBottomPressed: false,
      isLeftPressed: false,
      isRightPressed: false,
      isCenterPressed: false,
      direction: -1,
      // 用于存储方向（0:上, 1:下, 2:左, 3:右）
      longPressGimbalEvent: 0,
      // 0:结束，1:开始
      pressTimer: null,
      // 用于记录长按计时器
      isLongPress: false,
      // 新增一个标志以区分长按与单击
      location: '',
      debounceTimer: null,
      // 用于存储防抖定时器
      lastParams: null,
      defaultView: '',
      defaultViewOptions: [{
        value: '0',
        label: 'Full Screen'
      }, {
        value: '1',
        label: 'Partyline view'
      }],
      params: {},
      locked: '',
      autoFocus: '',
      autoExposure: '',
      cameraPosition: '',
      cameraOptionsMapping: {
        1: 'Main (Rear Camera)',
        0: 'Selfie (Front-facing Camera)',
        3: 'Main+Selfie (distant view)',
        4: 'Main+Selfie (near view)'
      },
      cameraOptions: [],
      resolutionOptions: [],
      resolution: '',
      fpsOptions: [],
      whiteBalanceAuto: '',
      whiteBalanceType: '',
      whiteBalanceOptions: [],
      fps: '',
      temperature: 0,
      zoom: 0,
      inputZoom: '',
      inputTemperature: '',
      tints: 0,
      inputTints: '',
      focus: 0,
      exposure: 0,
      inputFocus: '',
      inputExposure: ''
    };
  },
  watch: {
    anyWhereSetObj: {
      handler(newValue) {
        // 根据最新的 anyWhereSetObj 来更新
        this.initializeSettingsBasedOn(newValue);
      },
      deep: true,
      immediate: true
    },
    singChannel: {
      handler(newValue) {
        if (newValue && newValue.audioTrack) {
          const media = new MediaStream();
          media.addTrack(newValue.audioTrack._mediaStreamTrack);
          audioContextObj.audioTrack(media, 'volume');
          setTimeout(() => {
            audioContextObj.resumeAudio('volume');
          }, 1000);
        }
      },
      immediate: true
    }
  },
  async mounted() {
    this.getLocation();
    this.initializeSettingsBasedOn(this.anyWhereSetObj);
  },
  computed: {
    ...mapState({
      Config: state => state.config
    }),
    // anyWhere所有限制规则
    // 1.当用户选择 2160p/480p 或者 fps:50/60 时，禁止 双镜操作
    // 2.当用户打开 双镜 时，禁止选择 分辨率：2160p/480p 和  帧率:50/60
    // 3.当选择分辨率是1080i，fps不是50或60，则禁用该fps选项

    // 1.用户选择 2160p/480p或者 fps:50/60 时，禁止 双镜操作
    computedCameraOptions() {
      return this.cameraOptions.map(option => {
        const isDisabled = (this.resolution === '2160p' || this.resolution === '480p' || this.fps === '50' || this.fps === '60') && (option.value === '4' || option.value === '3') && !this.resolution.includes('i');
        return {
          ...option,
          disabled: isDisabled
        };
      });
    },
    // 2.1用户选择双镜操作，禁止 选择 分辨率：2160p/480p
    computedResolutionOptions() {
      return this.resolutionOptions.map(option => {
        const isDisabled = (option.label === '2160p' || option.label === '480p') && (this.cameraPosition === '4' || this.cameraPosition === '3');
        return {
          ...option,
          disabled: isDisabled
        };
      });
    },
    // 2.2用户选择双镜操作禁止 选择帧率:50/60，
    // 3.分辨率是1080i，fps不是50或60，则禁用
    computedFpsOptions() {
      return this.fpsOptions.map(option => {
        // 如果选项是50或60帧率
        const isOption50or60 = option.label === '50' || option.label === '60';
        // 如果是双镜头模式
        const isDualCameraPosition = this.cameraPosition === '4' || this.cameraPosition === '3';
        // 如果是1080i分辨率，仅允许50和60帧率的选项
        // 如果是双镜头模式，并且选项是50或60帧率，则禁用
        // 如果不是1080i并存在任何其它条件，则按原有逻辑启用或禁用选项
        let isDisabled;
        if (this.resolution === '1080i') {
          // 如果分辨率是1080i，但选项不是50或60，则禁用
          isDisabled = !isOption50or60;
        } else {
          // 如果不是1080i分辨率
          // 如果是双镜头且选项是50或60，则禁用
          isDisabled = isDualCameraPosition && isOption50or60;
        }
        return {
          ...option,
          disabled: isDisabled
        };
      });
    }
  },
  methods: {
    // 显示标题部分操作提示
    showOperationPrompt(status) {
      if (this.operationTimer) {
        clearTimeout(this.operationTimer);
      }
      this.operationStatus = status;
      this.operationMessage = status === 'success' ? this.$t('commonFunction.operateSuccessful') : this.$t('commonFunction.operateFailed');
      // 设置一个定时器在2秒后隐藏提示
      this.operationTimer = setTimeout(() => {
        this.operationStatus = null;
        this.operationMessage = '';
        this.operationTimer = null;
      }, 2000);
    },
    isDisabled(key) {
      return this.anyWhereSetObj[key] === null;
    },
    getLocation() {
      this.axios.post(`${this.Config.urlInfo.geoServiceUrl}/Out/getGpsInfoByMultiIpOrPeerIdServlet?partyCode=${this.partyCode}`, {
        peerId: this.peerId,
        whiteListKey: 'tvu_geo_white_list_'
      }).then(res => {
        if (!res) return;
        if (res.data.code === '80A01020') {
          var _res$data$data$;
          const fullAddress = (_res$data$data$ = res.data.data[0]) === null || _res$data$data$ === void 0 ? void 0 : _res$data$data$.address;
          if (fullAddress) {
            var _parts, _parts2;
            const parts = fullAddress.split(',');
            this.location = `${(_parts = parts[parts.length - 2]) === null || _parts === void 0 ? void 0 : _parts.trim()}, ${(_parts2 = parts[parts.length - 3]) === null || _parts2 === void 0 ? void 0 : _parts2.trim()}`;
          }
        }
      });
    },
    initializeSettingsBasedOn(anyWhereSetObj) {
      this.locked = anyWhereSetObj.lock && anyWhereSetObj.lock || this.locked;
      // 初始化曝光
      this.autoExposure = anyWhereSetObj.autoExposure && anyWhereSetObj.autoExposure || this.autoExposure;
      // this.inputExposure = this.exposure = anyWhereSetObj.exposure && Number(anyWhereSetObj.exposure) || this.inputExposure || this.exposure
      this.inputExposure = this.exposure = anyWhereSetObj.exposure !== undefined && anyWhereSetObj.exposure !== null ? Number(anyWhereSetObj.exposure) : this.inputExposure || this.exposure;
      // 初始化自动聚焦
      this.autoFocus = anyWhereSetObj.autoFocus && anyWhereSetObj.autoFocus || this.autoFocus;
      this.inputFocus = this.focus = anyWhereSetObj.focusDistance !== undefined && anyWhereSetObj.focusDistance !== null ? Number(anyWhereSetObj.focusDistance) : this.inputFocus || this.focus;
      // 分辨率/码率
      this.fps = anyWhereSetObj.fps && anyWhereSetObj.fps || this.fps;
      this.resolution = anyWhereSetObj.resolution && anyWhereSetObj.resolution.toLowerCase() || this.resolution.toLowerCase();
      this.resolutionOptions = anyWhereSetObj.resolutionOptions && anyWhereSetObj.resolutionOptions.split(',').map(resolutionValue => ({
        label: `${resolutionValue}p`
      })) || this.resolutionOptions;
      if (this.resolutionOptions.some(obj => obj.label === '1080p')) {
        // 在1080P对象之后插入1080i新的对象
        const index1080P = this.resolutionOptions.findIndex(obj => obj.label === '1080p');
        this.resolutionOptions.splice(index1080P + 1, 0, {
          label: '1080i'
        });
      }
      this.fpsOptions = anyWhereSetObj.fpsOptions && anyWhereSetObj.fpsOptions.split(',').map(fpsValue => ({
        label: fpsValue
      })) || this.fpsOptions;
      // 缩放的值
      this.inputZoom = this.zoom = anyWhereSetObj.zoom && Number(anyWhereSetObj.zoom) || this.inputZoom || this.zoom;
      // 初始化温度和色调滑块的值
      this.inputTemperature = this.temperature = anyWhereSetObj.whiteBalance && Number(anyWhereSetObj.whiteBalance.temp) || this.inputTemperature || this.temperature;
      this.inputTints = this.tints = anyWhereSetObj.whiteBalance && Number(anyWhereSetObj.whiteBalance.tint) || this.inputTints || this.tints;
      // cameraOptions 初始化
      this.cameraPosition = anyWhereSetObj.cameraPosition && anyWhereSetObj.cameraPosition || this.cameraPosition;
      this.cameraOptions = anyWhereSetObj.cameraPosition && anyWhereSetObj.cameraOptions.split(',').map(optionValue => ({
        value: optionValue,
        label: this.cameraOptionsMapping[optionValue] || 'Unknown'
      })) || this.cameraOptions;
      // 初始化白平衡自动
      this.whiteBalanceOptions = anyWhereSetObj.whiteBalancePredefined && JSON.parse(anyWhereSetObj.whiteBalancePredefined || this.whiteBalanceOptions).map(item => {
        var _label$charAt;
        // 获取预定义白平衡的键（如daylight）和值（如{temp: 5200, tint: 0}）
        const label = Object.keys(item)[0]; // 获取对象的键，作为标签
        const {
          temp,
          tint
        } = item[label]; // 解构赋值获取温度和色调
        return {
          label: ((_label$charAt = label.charAt(0)) === null || _label$charAt === void 0 ? void 0 : _label$charAt.toUpperCase()) + label.slice(1),
          // 大写首字母
          temp: `${temp}`,
          tint: `${tint}`
        };
      });
      // 如果是安卓机型则不添加Manual(不支持手动)
      if (this.platForm != '11') {
        this.whiteBalanceOptions && this.whiteBalanceOptions.splice(1, 0, {
          label: 'Manual'
        });
      }
      this.whiteBalanceAuto = anyWhereSetObj.whiteBalanceAuto && anyWhereSetObj.whiteBalanceAuto || this.whiteBalanceAuto;
      // 初始化获取下拉框场景的选项
      this.updateSelectBySliders();
      // 默认视图
      this.defaultView = anyWhereSetObj.defaultView && anyWhereSetObj.defaultView || this.defaultView;
      // 是否支持云台功能
      this.isSupportGimbal = anyWhereSetObj.isSupportGimbal && anyWhereSetObj.isSupportGimbal || this.isSupportGimbal;
    },
    getIconClass(label) {
      const iconMapping = {
        Daylight: 'iconfont icon-daylight',
        Shade: 'iconfont icon-shade',
        Cloudy: 'iconfont icon-cloudy',
        Tungsten: 'iconfont icon-tungsten',
        Fluorescent: 'iconfont icon-fluorescent',
        Flash: 'iconfont icon-flash',
        Manual: 'iconfont icon-manual'
      };
      return iconMapping[label] || 'iconfont icon-daylight';
    },
    // 更新温度和色调滑块的值
    changeWhiteBalanceAuto(value) {
      if (value !== 'Manual') {
        const selectedOption = this.whiteBalanceOptions.find(option => option.label === value);
        if (selectedOption) {
          // 更新温度和色调滑块的值
          this.temperature = Number(selectedOption.temp);
          this.tints = Number(selectedOption.tint);
          this.inputTemperature = Number(selectedOption.temp); // 同步更新输入值
          this.inputTints = Number(selectedOption.tint);
        }
        this.changeProperty('whiteBalance');
      } else {
        // 手动
        this.whiteBalanceAuto = 0;
        this.changeProperty('whiteBalanceAuto');
      }
    },
    // 更新场景下拉选项
    updateSelectBySliders() {
      // 初始化一个变量来记录找到的匹配项的标签
      let matchedLabel = null;

      // 遍历所有白平衡选项
      this.whiteBalanceOptions && this.whiteBalanceOptions.forEach(option => {
        // 检查当前选项的温度和色调是否与滑块的值完全相等
        if (this.temperature == option.temp && this.tints == option.tint) {
          matchedLabel = option.label; // 如果找到匹配项，记录其标签
        }
      });

      // 如果找到匹配项，更新 select 绑定值
      if (matchedLabel !== null) {
        this.whiteBalanceType = matchedLabel;
      } else {
        this.whiteBalanceType = 'Manual';
      }
    },
    deBounceChangeProperty(type, value) {
      this.lastParams = {
        type,
        value
      };
      // 清理现有的防抖定时器
      clearTimeout(this.debounceTimer);
      // 设置新的防抖定时器
      this.debounceTimer = setTimeout(() => {
        this.changeProperty(this.lastParams.type, this.lastParams.value);
      }, 500);
    },
    changeProperty(type, value) {
      this.params = {
        partyCode: Number(this.partyCode),
        peerId: this.peerId,
        setting: {
          key: type
        }
      };
      if (type == 'resolutionFps') {
        var _this$resolution;
        // 如果选择的是1080i且fps为25或30,则将fps设置为50
        if (value == '1080I' && (this.fps == '25' || this.fps == '30')) {
          this.fps = '50';
        }
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            height: Number((_this$resolution = this.resolution) === null || _this$resolution === void 0 ? void 0 : _this$resolution.replace(/(p|i)$/, '')),
            fps: Number(this.fps),
            interlace: this.resolution == '1080i' ? 1 : 0
          })
        };
      } else if (type == 'switchCamera') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            position: this.cameraPosition
          })
        };
      } else if (type == 'lockScreen') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            lock: this.locked
          })
        };
      } else if (type == 'autoFocus') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            auto: this.autoFocus
          })
        };
      } else if (type == 'autoExposure') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            auto: this.autoExposure
          })
        };
      } else if (type == 'whiteBalanceAuto') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            auto: this.whiteBalanceAuto
          })
        };
      } else if (type == 'whiteBalance') {
        this.updateSelectBySliders();
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            temp: Number(this.inputTemperature),
            tint: Number(this.inputTints)
          })
        };
      } else if (type == 'focusDistance') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            distance: Number(this.inputFocus)
          })
        };
      } else if (type == 'exposure') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            exposure: Number(this.inputExposure)
          })
        };
      } else if (type == 'zoom') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            zoom: value || Number(this.inputZoom)
          })
        };
      } else if (type == 'defaultView') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            display: this.defaultView
          })
        };
      } else if (type == 'longPressGimbal') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            direction: this.direction,
            event: this.longPressGimbalEvent
          })
        };
      } else if (type == 'singleClickGimbal') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            direction: this.direction
          })
        };
      } else if (type == 'resetGimbal') {
        this.params.setting = {
          key: type,
          value: null
        };
      }
      this.axios.post('/partyline-backend/anywhere/setting', this.params).then(res => {
        if (res.data.errorCode != '0x0') {
          if (type != 'resetGimbal' && type != 'longPressGimbal' && type != 'singleClickGimbal') {
            this.$message({
              type: 'error',
              message: res.data.errorMessage
            });
          } else {
            this.showOperationPrompt('failure');
          }
          if (type == 'resetGimbal') {
            this.isCenterPressed = false;
          }
        } else {
          // 由于安卓机型不支持手动调节并不显示场景对应的值，
          // 所以需要当关闭自动白平衡时再次设置一次白平衡值（temp和tint）
          if (this.whiteBalanceAuto == 0 && this.platForm == '11' && type == 'whiteBalanceAuto') {
            this.changeProperty('whiteBalance');
            return;
          }
          if (type == 'resetGimbal') {
            this.isCenterPressed = false;
          }
          if (type != 'resetGimbal' && type != 'longPressGimbal' && type != 'singleClickGimbal') {
            this.$message({
              type: 'success',
              message: this.$t('commonFunction.operateSuccessful')
            });
          } else {
            this.showOperationPrompt('success');
          }
        }
      });
    },
    resetGimBal() {
      this.isCenterPressed = true;
      this.changeProperty('resetGimbal');
    },
    handleMousedown(e) {
      this.direction = e;
      if (this.direction == 0) {
        this.isTopPressed = true;
      } else if (this.direction == 1) {
        this.isBottomPressed = true;
      } else if (this.direction == 2) {
        this.isLeftPressed = true;
      } else if (this.direction == 3) {
        this.isRightPressed = true;
      }
      // 启动按下定时器
      this.pressTimer = setTimeout(() => {
        this.isLongPress = true; // 设置长按标志
        this.longPressGimbalEvent = 1; // 开始长按
        this.sendLongPressGimbalCommand(); // 开始发送长按命令
      }, 300); // 0.3秒长按
    },

    handleMouseup() {
      clearTimeout(this.pressTimer); // 清除按下定时器
      // 如果是长按，不执行单击
      if (this.isLongPress) {
        this.longPressGimbalEvent = 0;
        this.changeProperty('longPressGimbal'); // 结束长按
        this.isTopPressed = false;
        this.isBottomPressed = false;
        this.isLeftPressed = false;
        this.isRightPressed = false;
      } else {
        this.singleClickGimbal(); // 调用单击函数
      }

      this.isLongPress = false; // 重置长按标志
    },

    sendLongPressGimbalCommand() {
      this.changeProperty('longPressGimbal');
    },
    handleMouseLeave() {
      clearTimeout(this.pressTimer);
      if (this.isLongPress) {
        this.longPressGimbalEvent = 0; // 重置长按事件
        this.changeProperty('longPressGimbal'); // 结束长按
        this.isTopPressed = false;
        this.isBottomPressed = false;
        this.isLeftPressed = false;
        this.isRightPressed = false;
      }
      this.isLongPress = false; // 重置长按标志
    },

    singleClickGimbal() {
      this.changeProperty('singleClickGimbal');
      this.isTopPressed = false;
      this.isBottomPressed = false;
      this.isLeftPressed = false;
      this.isRightPressed = false;
    },
    changeInputValue(value, property) {
      let newValue = Number(value);
      // 定义一个对象，映射属性到它们各自的范围键和更改函数
      const propertySettings = {
        tint: {
          rangeKey: 'whiteBalanceRange',
          changeFunction: 'whiteBalance',
          property: 'inputTints'
        },
        exposure: {
          rangeKey: 'exposureRange',
          changeFunction: 'exposure',
          property: 'inputExposure'
        },
        focus: {
          rangeKey: 'focusDistanceRange',
          changeFunction: 'focusDistance',
          property: 'inputFocus'
        },
        temperature: {
          rangeKey: 'whiteBalanceRange',
          changeFunction: 'whiteBalance',
          property: 'inputTemperature'
        }
      };

      // 获取当前属性的设置
      const settings = propertySettings[property];
      // 解析指定范围
      const parsedRange = JSON.parse(this.anyWhereSetObj[settings.rangeKey]);
      // 确定最大值和最小值的键
      const maxKey = property === 'temperature' ? 'tempMax' : `${property}Max`;
      const minKey = property === 'temperature' ? 'tempMin' : `${property}Min`;
      // 根据范围调整值
      if (newValue > Number(parsedRange[maxKey])) {
        newValue = Number(parsedRange[maxKey]);
      } else if (newValue < Number(parsedRange[minKey])) {
        newValue = Number(parsedRange[minKey]);
      }

      // 更新相应的属性和状态
      if (property == 'tint') property = 'tints';
      this[settings.property] = this[property] = newValue;
      // 调用更改属性的方法
      this.deBounceChangeProperty(settings.changeFunction);
    },
    changeZoomInputValue(value, isreset) {
      if (!this.anyWhereSetObj.zoom || !this.anyWhereSetObj.zoomRange) return;
      let zoomValue = Number(value);
      if (zoomValue > Number(JSON.parse(this.anyWhereSetObj.zoomRange).zoomMax)) {
        zoomValue = Number(JSON.parse(this.anyWhereSetObj.zoomRange).zoomMax);
      } else if (zoomValue < Number(JSON.parse(this.anyWhereSetObj.zoomRange).zoomMin)) {
        zoomValue = Number(JSON.parse(this.anyWhereSetObj.zoomRange).zoomMin);
      }
      this.inputZoom = this.zoom = zoomValue;
      if (isreset) {
        this.deBounceChangeProperty('zoom', 1);
      } else {
        this.deBounceChangeProperty('zoom');
      }
    },
    closeDialog() {
      this.info.show = false;
      this.$emit('closeAnywherePreview');
    }
  }
};